import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: calc(100vh - 80px);
  padding: 24px;
  background: #f8f9fa;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const Header = styled.div`
  margin-bottom: 20px;
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: #1d3557;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const ContentWrapper = styled.div`
  margin-top: 20px;
`;
